$(() => {
  const $toggleTrigger = $(".toggle-trigger");
  const $toggleContent = $(".toggle-content");

  /**
   * Trigger to handle the View More/Less Doctor Testimonials
   */
  $toggleTrigger.on("click", (e) => {
    e.preventDefault();
    $toggleTrigger.toggleClass("active");
    $toggleContent.toggleClass("d-none");
    if ($toggleTrigger.find("#testimonials-toggle")) {
      const $testimonialsTrigger = $toggleTrigger.find("#testimonials-toggle");
      const moreLess = $toggleTrigger.hasClass("active") ? "Less" : "More";
      $testimonialsTrigger.html(`View ${moreLess} Doctor Testimonials`);
    }
  });
});
